import { render, staticRenderFns } from "./Alvara.vue?vue&type=template&id=61554fd2&scoped=true&"
import script from "./Alvara.vue?vue&type=script&lang=js&"
export * from "./Alvara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61554fd2",
  null
  
)

export default component.exports